<template>
  <div
    @dblclick.exact="openInWinOrMax"
    @click.ctrl="openBookInRealWin"
    tabindex="0"
    ref="container"
    class="container"
    @keydown="doKeyPress"
    @keyup="doKeyUp"
    :id="'the-book-container' + tabId"
    @contextmenu="setCurrentPage"
  >
    <p class="spinner" v-if="$store.state.tabsManager.showSpinner">
      <spinnerCircle />
    </p>
    <BaseContextMenu>
      <div
        class="menu-item"
        @click="print"
        :class="{ disable: !bookAllowedToPrint }"
      >
        {{ $t("bookPrint.btnTxt") }}
      </div>
      <div
        class="menu-item"
        :class="{ disable: !bookAllowedToPrint }"
        @click="setStartPage"
      >
        {{ $t("bookPrint.startFromHere") }}
      </div>
      <div
        class="menu-item"
        :class="{ disable: !showEnd || !bookAllowedToPrint }"
        @click="printToHere"
      >
        {{ $t("bookPrint.endHere") }}
      </div>
      <div class="seperator"></div>
      <div class="menu-item" @click="setOcr">
        {{ $t("ocr.selectArea") }}
      </div>
      <div class="menu-item" @click="addextens('comment')" v-kiosk>
        {{ $t("general.add") }} {{ $t("comments.comment") }}
      </div>
      <div class="menu-item" @click="addextens('key')" v-kiosk>
        {{ $t("general.add") }} {{ $t("keys.key") }}
      </div>
      <div class="menu-item" @click="addextens('marker')" v-kiosk>
        {{ $t("general.add") }} {{ $t("personalExtensions.marker") }}
      </div>
      <div class="menu-item" @click="addextens('link')" v-kiosk>
        {{ $t("general.add") }} {{ $t("personalExtensions.innerLink") }}
      </div>
      <div class="menu-item" @click="addNewTziun" v-kiosk>
        {{ $t("general.add") }} {{ $t("tsiyunim.myTsiyun") }}
      </div>
      <div class="menu-item" @click="addBookmark" v-kiosk v-version.up="23">
        {{ $t("general.setBookmarkPosition") }}
      </div>
      <div class="seperator"></div>
      <div class="menu-item" @click="openBookInWin">
        {{ $t("toolbox.openBook") }}
      </div>
      <div v-if="!hasPinnedPage" class="menu-item" @click="pinPage" v-kiosk>
        {{ $t("toolbox.openOnCurrentPage") }}
      </div>
      <div v-if="hasPinnedPage" class="menu-item" @click="unPinPage" v-kiosk>
        {{ $t("toolbox.removeOpenOnCurrentPage") + pinnedPage }}
      </div>
      <div
        class="menu-item"
        @click="createShortcutForThisBook"
        v-kiosk
        v-version.up="23"
      >
        {{ $t("customShortcuts.setShortcut") }}
      </div>
    </BaseContextMenu>
    <pagesScroller
      @addexten="$emit('addexten')"
      v-if="list.length"
      :items="list"
      :tabId="tabId"
      :raw="imageContent"
      :scrollToPosition="newScrollToPosition"
      :refresh="renderPage"
      :scrollToItem="scrollToItem"
      :offset="offset"
      @toggleocr="toggleOCR"
      @inc-page="incPage"
      :mm="mm"
      :drawFs="drawFs"
      :isscrolling="scrolling"
      @login="$emit('login')"
      :rotateImage="rotateImage"
      @setScrollTo="(p) => (scrollToItem = p)"
      ref="scroller"
    ></pagesScroller>
    <scrollButton
      v-show="
        this.$store.getters[`tabs/${this.tabId}/getBookmarkStatus`] != 'off'
      "
      icon="bookmark"
      v-tooltip="{ content: this.$t('general.jumpToBookmarkPosition') }"
      @scrollTo="scrollToBookmark"
      v-version.up="23"
    >
    </scrollButton>
    <!--     <magnifyImg
      @dragging="setMagnifyData"
      v-if="showMagnify"
      :bookId="book"
      :page="magnifyPage"
      :magnifyPosition="magnifyPosition"
      :refresh="refresh"
    /> -->
  </div>
</template>

<script>
import pageItem from "@/components/book/pageItem.vue";
import pagesScroller from "@/components/book/pagesScroller.vue";
import { goToPage as go, getImageObject } from "@/services/bookData.js";
import { allowedToPrint, startPrint } from "@/services/print.js";

import { mapActions, mapGetters, mapState } from "vuex";
import winManager from "@/services/book_win";
import magnifyMix from "@/mixing/magnifier";
import magnifyImg from "./magnifyImg.vue";
import { IPUserNoPersDataMsg } from "@/services/userBooksData.js";
import scrollButton from "@/components/book/scrollButton.vue";

export default {
  components: {
    pageItem,
    pagesScroller,
    scrollButton,
    //  magnifyImg,
  },
  mixins: [magnifyMix],
  props: {
    list: Array,
    tabId: String,
    drawData: Object,
    mm: Boolean,
    drawFs: Boolean,
    rotateImage: Boolean,
  },
  data() {
    return {
      thepage: 0,
      imageContent: null,
      searchTimer: null,
      lastKey: 0,
      scrollToItem: 0,
      offset: 0,
      renderPage: false,
      scrolling: false,
      startPrintFrom: -1,
      endPrint: -1,
      currentClickedPage: -1,
      pinnedPage: 0,
      mouseRClickYPosition: -1,
      newScrollToPosition: 0,
    };
  },
  watch: {
    resize: function (val, oldVal) {
      this.renderPage = !this.renderPage;
    },
    fullScreen: function (val, oldVal) {
      this.doResize();
    },
    scrollTo: function (page, oldVal) {
      this.scrollToPage(page);
    },
    splitterChange: function (val, oldVal) {
      this.doResize();
    },
    book: async function (val, oldVal) {
      this.imageContent = null;
      //this.$store.dispatch(`tabs/${this.tabId}/setBookmarkStatus`, "off");
    },
    tsiyunSearch: async function (val, oldVal) {
      if (this.tabId != this.currentTabId) return;
      if (val == "") return;
      if (this.getTabData.tsiyunim.length == 0) return;

      //go to page of tsiyun
      let search = this.getTabData.tsiyunim.filter(
        (t) => t.title.indexOf(val) >= 0
      );
      if (search[0]) this.scrollToPage(search[0].page);
    },
  },
  computed: {
    ...mapState("bookList", ["tsiyunSearch"]),
    ...mapState("tabsManager", ["currentTabId"]),
    ...mapGetters("tabsManager", ["isWindow"]),
    ...mapGetters("user", ["isIPLimited", "isUserGuest"]),
    bookAllowedToPrint() {
      if (this.isUserGuest && !globalThis.DEV_CONNECT_USER_TO_FREE_AUTO)
        return false;
      if (!this.$store.getters[`tabs/${this.tabId}/isBookAllowedToUser`])
        return false;
      if (!allowedToPrint(this.book.toString())) return false;
      return true;
    },
    hasPinnedPage() {
      let pinnedPages = this.userSettings.settings.pinnedPages;
      if (!pinnedPages) return false;
      pinnedPages = new Map(JSON.parse(pinnedPages));
      /*  let currBook = pinnedPages.findIndex(
        (p) => p.book == this.getTabData.book
      ); */
      return pinnedPages.has(this.getTabData.book.toString());
    },
    showEnd() {
      return this.startPrintFrom != -1;
    },
    getTabData() {
      return this.$store.getters["tabs/" + this.tabId + "/getTabData"];
    },
    ...mapGetters("tabsManager", ["getSearchPage"]),
    pageHeight() {
      return this.$store.state.tabs[this.tabId].pageHeight;
    },
    getTsiyunim() {
      return this.getTabData.tsiyunim || [];
      return this.$store.getters[`tabs/${this.tabId}/getTsiyunim`];
    },
    isMinimized() {
      return this.$store.state.tabs[this.tabId].minimize;
    },
    tsiyunimType1() {
      try {
        return this.getTsiyunim.filter((t) => t.type == 1);
      } catch (ex) {
        return [];
      }
    },
    tsiyunimType2() {
      try {
        return this.getTsiyunim.filter((t) => t.type == 2);
      } catch (ex) {
        return [];
      }
    },
    tsiyunimSorted() {
      return [...this.tsiyunimType2, ...this.tsiyunimType1];
    },
    getUserTsiyuns() {
      return this.getTabData.usertsiyuns || [];

      return this.$store.getters[`tabs/${this.tabId}/getUserTsiyuns`];
    },
    getPages() {
      //return this.$store.getters[`tabs/${this.tabId}/getPages`];
      return this.getTabData.pages || [];
    },
    book() {
      return this.getTabData.book;
    },
    getBookFit() {
      return this.$store.getters[`tabs/${this.tabId}/getBookFit`];
    },
    resize() {
      return this.$store.state.tabs[this.tabId].resize;
    },
    page() {
      if (this.tabId == "") return 0;
      let page = this.$store.state.tabs[this.tabId];

      if (page != undefined) page = page.page;
      else page = 1;
      return page;
    },
    scrollTo() {
      return this.$store.state.tabs[this.tabId].scrollTo;
    },
    fullScreen() {
      return this.$store.state["tabsManager"].fullScreen;
    },
    splitterChange() {
      return this.$store.state["tabsManager"].splitterChange;
    },
  },
  methods: {
    ...mapActions("userRecentBooks", ["addRecentBook"]),
    ...mapActions("tabsManager", [
      "setPageHeight",
      "setCurrentScrollTo",
      "setResizeToggle",
      "initCropper",
      "setSearchPage",
      "addToSearchPage",
    ]),
    ...mapActions("bookPopups", ["setOCREnable"]),
    ...mapActions("popupOnceComp", [
      "toggleVisible",
      "setSlotShow",
      "setTabId",
    ]),
    ...mapActions("bookPersonalExtensions", [
      "setAddEtensType",
      "closeExtens",
      "startCreateExtentionMode",
    ]),
    setCurrentPage(e) {
      this.mouseRClickYPosition = e.target.offsetParent.offsetTop + e.offsetY;
      try {
        this.currentClickedPage = parseInt(e.target.getAttribute("page"));
      } catch {
        this.currentClickedPage = 0;
      }
    },
    setStartPage() {
      if (this.bookAllowedToPrint)
        this.startPrintFrom = this.currentClickedPage;
    },
    printToHere() {
      if (!this.bookAllowedToPrint) return;
      if (!this.showEnd) return;
      if (startPrint(this.tabId))
        this.$emit("print", {
          show: true,
          from: this.startPrintFrom,
          to: this.currentClickedPage,
        });
      this.startPrintFrom = -1;
    },
    zoom(inc) {
      let currZoom = this.$store.getters["tabs/" + this.tabId + "/getZoom"];
      if (inc) currZoom += 10;
      else currZoom -= 10;

      if (currZoom < 40) currZoom = 40;
      if (currZoom > 250) currZoom = 250;
      this.$store
        .dispatch(`tabs/${this.tabId}/setBookFit`, "width", {
          root: true,
        })
        .then(() => {
          this.$store.dispatch(
            `tabs/${this.tabId}/setZoom`,
            { zoom: currZoom },
            {
              root: true,
            }
          );
        });
    },
    triggerResize() {
      this.$store.dispatch(`tabs/${this.tabId}/triggerResize`, null, {
        root: true,
      });
    },
    doKeyUp(event) {
      let numlock = event.getModifierState("NumLock");
      switch (event.code) {
        case "ShiftLeft":
        case "ShiftRight":
          this.$store.state.shiftPress = false;
          break;
        case "ArrowUp":
        case "PageUp":
        case "Numpad8":
        case "Numpad9":
          if ((event.code == "Numpad8" || event.code == "Numpad9") && numlock)
            break;

          clearInterval(globalThis.scrollInterval);
          clearInterval(globalThis.clickBookInterval);
          globalThis.scrollInterval = null;
          globalThis.clickBookInterval = null;

          break;
        case "ArrowDown":
        case "PageDown":
        case "Numpad3":
        case "Numpad2":
          if ((event.code == "Numpad2" || event.code == "Numpad3") && numlock)
            break;

          clearInterval(globalThis.scrollInterval);
          clearInterval(globalThis.clickBookInterval);

          globalThis.scrollInterval = null;
          globalThis.clickBookInterval = null;

          break;
      }
    },
    doKeyPress(event) {
      const NumLockEnabled = event.getModifierState
        ? event.getModifierState("NumLock")
        : false;

      switch (event.code) {
        case "Equal":
          event.stopPropagation();
          event.preventDefault();
          if (!event.shiftKey) break;
          this.zoom(true);
          break;
        case "NumpadAdd":
          event.stopPropagation();
          event.preventDefault();
          this.zoom(true);
          break;
        case "Minus":
          event.stopPropagation();
          event.preventDefault();
          if (!event.shiftKey) break;
          this.zoom(false);
          break;
        case "NumpadSubtract":
          event.stopPropagation();
          event.preventDefault();
          this.zoom(false);
          break;
        case "KeyP":
          if (event.ctrlKey) {
            if (this.bookAllowedToPrint) {
              if (startPrint(this.tabId)) this.$emit("print", { show: true });
              this.$nextTick(() => {
                document.getElementById("printToPrinterBtn").click();
              });
            } else this.searchPage(event);
          }
          break;
        /*   case "KeyN":
          // if (event.ctrlKey) {
          this.toggleMagnifier();
          //   }

          break; */

        case "Space":
          this.searchPage(event);
          event.stopPropagation();
          event.preventDefault();
          break;
        case "Numpad4":
        case "ArrowLeft":
          if (event.code == "Numpad4" && NumLockEnabled) {
            this.searchPage(event);
            break;
          }
          this.incPage(1);
          break;
        case "Numpad6":
        case "ArrowRight":
          if (event.code == "Numpad6" && NumLockEnabled) {
            this.searchPage(event);
            break;
          }
          this.incPage(-1);
          break;
        case "PageUp":
        case "Numpad9":
          if (event.code == "Numpad9" && NumLockEnabled) {
            this.searchPage(event);
            break;
          }
          // event.stopPropagation();
          // event.preventDefault();
          // this.incPage(-10);
          break;
        case "PageDown":
        case "Numpad3":
          if (event.code == "Numpad3" && NumLockEnabled) {
            this.searchPage(event);
            break;
          }
          // event.stopPropagation();
          // event.preventDefault();
          // this.incPage(10);
          break;
        default:
          this.searchPage(event);
      }
    },
    openBookInRealWin() {
      const bookId = this.getTabData.book;
      const page = this.getTabData.page;
      const w = 100;
      const h = 100;
      const fs = this.book?.fs;
      const fsName = fs ? fs.fs : 0;
      const end = fs ? fs.end : 0;
      const start = fs ? fs.start : 0;
      const tabId = Math.floor(Math.random() * 1000000);
      const params = ["height=" + screen.height, "width=" + screen.width].join(
        ","
      );
      window.open(
        globalThis.APP_URL +
          `#/book/${bookId}/p/${page}/t/${tabId}/fs/${fsName}/start/${start}/end/${end}/c`,
        "_blank" + tabId,
        params
      );
    },
    openBookInWin() {
      winManager.createWinBook(
        this.getTabData.book,
        this.getTabData.page,
        null,
        null,
        null,
        null,
        this.getTabData.drawData?.fs
      );
    },
    pinPage() {
      let pinnedPages = this.userSettings.settings.pinnedPages;
      if (!pinnedPages) pinnedPages = new Map();
      else pinnedPages = new Map(JSON.parse(pinnedPages));
      pinnedPages.set(this.getTabData.book.toString(), this.getTabData.page);
      this.pinnedPage = this.getTabData.page;
      this.userSettings.setSettings(
        "pinnedPages",
        JSON.stringify(Array.from(pinnedPages.entries()))
      );
    },
    unPinPage() {
      let pinnedPages = this.userSettings.settings.pinnedPages;
      if (!pinnedPages) return;
      pinnedPages = new Map(JSON.parse(pinnedPages));

      pinnedPages.delete(this.getTabData.book.toString());
      this.pinnedPage = 0;
      this.userSettings.setSettings(
        "pinnedPages",
        JSON.stringify(Array.from(pinnedPages.entries()))
      );
    },
    async createShortcutForThisBook() {
      this.setTabId(this.tabId);
      this.setSlotShow("add-shortcut");
      this.toggleVisible();
    },
    openInWinOrMax() {
      if (!this.isWindow(this.tabId)) this.openBookInWin();
    },
    toggleOCR(show) {
      this.$emit("toggleocr", show);
    },
    searchPage(event) {
      //TODO search only letters and numbers
      this.lastKey = new Date().getTime();
      this.addToSearchPage(event.key);
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.doPageSearch, 1000);
    },
    doPageSearch() {
      try {
        let found;
        let searchtxt = this.getSearchPage;
        this.setSearchPage("");
        //this.resetPageSearch();
        //check if it a valid page number
        if (
          !isNaN(searchtxt) &
          (parseInt(searchtxt) <= this.getPages.length) &
          (parseInt(searchtxt) > 0)
        )
          this.$store.state.tabs[this.tabId].scrollTo = parseInt(searchtxt);
        //search in page names
        else {
          found = this.getPages.filter((page, i) =>
            page.pagedata[0].letter.includes(searchtxt)
          );

          if (found.length > 0)
            this.$store.state.tabs[this.tabId].scrollTo = found[0].position;
          //search in tsiyunim
          else {
            found = this.tsiyunimSorted.filter((tsiyun, i) =>
              tsiyun.title.includes(searchtxt)
            );

            if (found.length > 0)
              this.$store.state.tabs[this.tabId].scrollTo = found[0].page;
            //   search in user tsiyunim
            else {
              found = this.getUserTsiyuns.filter((tsiyun, i) =>
                tsiyun.title.includes(searchtxt)
              );

              if (found.length > 0)
                this.$store.state.tabs[this.tabId].scrollTo = found[0].page;
            }
          }
        }
      } catch (ex) {
        //console.error(ex);
      }
    },
    resetPageSearch() {
      if (new Date().getTime() - this.lastKey > 1000) this.setSearchPage("");
    },
    incPage(num) {
      this.scrolling = true;
      this.$nextTick(() => {
        let goTo = this.page + num;
        if (goTo < 1) goTo = 1;
        if (goTo > this.list.length) goTo = this.list.length;
        if (goTo != this.page) this.$store.state.tabsManager.showSpinner = true;
        go(goTo, this.tabId);
      });
    },

    doResize() {
      this.renderPage = !this.renderPage;
      return;
    },
    scrollToPage(page) {
      page.page != undefined
        ? (this.scrollToItem = page.page)
        : (this.scrollToItem = page);
      page.offset != undefined
        ? (this.offset = page.offset)
        : (this.offset = 0);
    },
    setOcr() {
      this.setOCREnable(true);
    },
    addNewTziun() {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.setTabId(this.tabId);
      this.setSlotShow("add-tsiyun");
      this.toggleVisible();
    },
    addextens(type) {
      if (this.isIPLimited) {
        IPUserNoPersDataMsg();
        return;
      }
      this.closeExtens(); //reset all before start
      this.setOCREnable(type == "marker" || this.ocrMode);
      this.setAddEtensType(type);

      this.startCreateExtentionMode();
    },
    addBookmark() {
      let pos =
        (this.mouseRClickYPosition - 25) / this.$refs.scroller.fullBookHeight();
      this.$store.dispatch(`tabs/${this.tabId}/setBookmarkPosition`, pos);
      this.$store.dispatch(`tabs/${this.tabId}/setBookmarkStatus`, "on");

      let currentSetting = this.userSettings.settings.bookmarks;
      if (!currentSetting) currentSetting = {};
      else currentSetting = JSON.parse(currentSetting);
      currentSetting[this.getTabData.book.toString()] = parseFloat(
        pos.toFixed(6)
      );

      this.userSettings.setSettings(
        "bookmarks",
        JSON.stringify(currentSetting)
      );
    },
    print() {
      if (!this.bookAllowedToPrint) return;
      if (startPrint(this.tabId) === true)
        this.$emit("print", {
          from: this.currentClickedPage,
          to: this.currentClickedPage,
          show: true,
        });
    },
    scrollToBookmark() {
      let fullHeight = this.$refs.scroller.fullBookHeight();
      let newTop =
        this.$store.getters[`tabs/${this.tabId}/getBookmarkPosition`] *
        fullHeight;
      if (this.newScrollToPosition == newTop) newTop--; //for reactivation
      this.newScrollToPosition = newTop;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.doResize);
    clearTimeout(this.searchTimer);
  },
  mounted() {
    // ;
    this.doResize();

    this.$nextTick(function () {
      window.removeEventListener("resize", this.doResize);
      window.addEventListener("resize", this.doResize);
    });
  },

  async created() {
    this.scrollToItem = this.page;
    try {
      let pinnedPages = this.userSettings.settings.pinnedPages;
      if (!pinnedPages) return;
      pinnedPages = new Map(JSON.parse(pinnedPages));
      let data = pinnedPages.get(this.getTabData.book.toString());
      if (data) this.pinnedPage = data;
    } catch {}
  },
};
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  outline: 0;
  /* margin: auto; */
}
.scroller {
  height: 100%;
}
.disable {
  cursor: "default" !important;
  color: "gray";
}
.spinner {
  position: absolute;
  z-index: 99999;
  left: 50%;
  top: calc(50% - 40px);
}
/* .seperator {
  border-bottom: 1px solid #e5e5e5 !important;
  height: 1px !important;
  background-color: transparent !important;
  width: 100%;
  margin: 3px;
} */
</style>
